class CustomSelectButtons extends HTMLElement {
  #current;
  #previous;
  #form;
  #frame;
  #resizeObserver = new ResizeObserver(() => this.#sync());

  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
    this.#form = this.querySelector('input')?.form;
    this.#form?.addEventListener('reset', this.#handleReset);
    this.#sync();
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
    this.#form?.removeEventListener('reset', this.#handleReset);
    this.#resizeObserver.disconnect();
    cancelAnimationFrame(this.#frame);
  }

  #handleChange = () => this.#sync();

  #handleReset = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#sync());
  };

  #sync() {
    const radios = Array.from(this.querySelectorAll('input[type="radio"]'));
    const current = radios.find((radio) => radio.checked);
    if (current !== this.#current) {
      this.#previous = current ? this.#current : undefined;
      this.#current = current;
    }
    if (!radios.includes(this.#previous)) this.#previous = undefined;

    const currentWidth = this.#current?.parentElement?.offsetWidth;
    const previousWidth = this.#previous?.parentElement?.offsetWidth;
    const group = this.querySelector('.variant-option');
    if (!group) return;

    radios.forEach((radio) => {
      radio.dataset.currentChecked = String(radio === this.#current);
      radio.dataset.previousChecked = String(radio === this.#previous);
    });
    for (const [property, width] of [
      ['--pill-width-current', currentWidth],
      ['--pill-width-previous', previousWidth],
    ]) {
      if (width) group.style.setProperty(property, `${width}px`);
      else group.style.removeProperty(property);
    }
  }
}

if (!customElements.get('custom-select-buttons')) {
  customElements.define('custom-select-buttons', CustomSelectButtons);
}
